import React, {Component} from "react";
import AuthService from "./AuthService";

const AuthContext = React.createContext({
    signinRedirectCallback: () => ({}),
    logout: () => ({}),
    signoutRedirectCallback: () => ({}),
    isAuthenticated: () => ({}),
    signinRedirect: () => ({}),
    signinSilentCallback: () => ({}),
    getAccessToken: () => ({}),
    onSilentRenewError: (fn) => ({})
});

export const AuthConsumer = AuthContext.Consumer;

class AuthProvider extends Component {
    render() {
        const authService = new AuthService({...this.props.config});
        return <AuthContext.Provider value={authService}>{this.props.children}</AuthContext.Provider>;
    }
}

export default AuthProvider;